<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 d-none d-md-inline-block">
          <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <div class="card form_laive" :class="{ validateClient: loading }">
            <div class="box_loader">
              <div class="loader"></div>
            </div>
            <div class="card-header">
              <div class="row">
                <div class="col-12 col-md-6">
                  <h3 class="mb-0">Listado de Pedído mínimo</h3>
                </div>
                <div class="col-12 col-md-6 text-right">
                  <router-link :to="{ name: 'Crear Pedido minimo' }"
                    ><base-button size="sm" type="info">Crear pedido mínimo</base-button></router-link
                  >
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row pb-4">
                <div class="col-md-3">
                  <template v-if="distribuidoraIdCurrent">
                    <span class="title_filter mr-2"
                      >Distribuidora: <strong>{{ distribuidoraNameCurrent }}</strong></span
                    >
                  </template>
                  <template v-else>
                    <span class="title_filter mr-2">Distribuidoras: </span>
                    <select
                      v-model.number="filter.iddistribuidora"
                      class="form-control"
                      style="display: inline-block; height: 43px"
                      name="distributor_select"
                      @change="changeData"
                    >
                      <option value="0">Todos</option>
                      <option v-for="item in distribuidoras" :value="item.idDistribuidora" :key="item.idDistribuidora">
                        {{ item.razonSocial }}
                      </option>
                    </select>
                  </template>
                </div>
                <div class="col-md-3">
                  <span class="title_filter mr-2">Tipo:</span>
                  <select
                    v-model.number="filter.tipo"
                    class="form-control"
                    style="display: inline-block; height: 43px"
                    name="distributor_select"
                    @change="changeData"
                  >
                    <option value="0">Todos</option>
                    <option value="1">Opcional</option>
                    <option value="2">Obligatorio</option>
                  </select>
                </div>
              </div>
              <!-- Real Table -->
              <el-table
                :data="queriedData"
                row-key="idPedidoMinimo"
                empty-text="No se encontraron resultados"
                header-row-class-name="thead-light"
              >
                <el-table-column v-for="column in tableColumns" :key="column.label" v-bind="column"> </el-table-column>
                <el-table-column label="Monto Minimo" prop="montoMinimo" width="170">
                  <template v-slot="{ row }"> S/{{ row.montoMinimo }} </template>
                </el-table-column>
                <el-table-column label="Tipo" prop="nombreTipo" width="160" />
                <el-table-column label="Creacion" prop="fechaCrea" width="150" />
                <el-table-column width="204" align="left">
                  <template v-slot:default="props">
                    <router-link
                      :to="{
                        name: 'Editar Pedido minimo',
                        params: { id: props.row.idPedidoMinimo },
                      }"
                      class="btn base-button btn-button btn-sm mr-3 edit"
                      >Editar</router-link
                    >
                    <base-button
                      class="delete"
                      type="button"
                      size="sm"
                      role="button"
                      @click="deletePedido(props.row.idPedidoMinimo)"
                      >Eliminar</base-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div class="">
                <p class="card-category d-none">Mostrando {{ from + 1 }} a {{ to }} de {{ total }} productos</p>
              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="filter.page"
                :per-page="pagination.perPage"
                :total="total"
                @click="changePaginate"
              >
              </base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { ElTable, ElTableColumn, ElSelect, ElOption, ElInput } from "element-plus";
import { mapGetters, mapActions } from "vuex";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import DashboardNavbar from "../Layout/DashboardNavbar";
import { useToast } from "vue-toastification";
import Notification from "@/components/Notification";
export default {
  components: {
    DashboardNavbar,
    RouteBreadCrumb,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElTable.name]: ElTable,
    [ElInput.name]: ElInput,
    [ElTableColumn.name]: ElTableColumn,
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
    distribuidoraNameCurrent() {
      const current = this.distribuidoras.find(
        (item) => Number(item.idDistribuidora) === Number(this.distribuidoraIdCurrent)
      );
      return current?.razonSocial || "";
    },
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
  },
  async mounted() {
    if (this.user.rol == 3) {
      this.distribuidoraIdCurrent = this.user.idDistribuidora;
      this.filter.iddistribuidora = this.user.idDistribuidora;
    }
    await this.fetchDistribuidoras();
    await this.fetchPedidoMinimoData();
  },
  methods: {
    showToast(text, type = "success") {
      const content = {
        component: Notification,
        props: {
          icon: "ni ni-bell-55",
          text,
          type,
        },
      };
      const toast = useToast();
      toast(content, {
        hideProgressBar: true,
        icon: false,
        closeButton: false,
        position: "top-right",
      });
    },
    fetchPedidoMinimoData() {
      const $this = this;
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      this.loading = true;
      return axios
        .post(process.env.VUE_APP_API_URL + "/pedidominimo/listar", this.filter, config)
        .then(function (response) {
          $this.loading = false;
          $this.pagination.perPage = response.data.data.length;
          $this.pagination.total = response.data.totalPage;
          return ($this.tableData = response.data.data);
        })
        .catch(function (error) {
          console.log("Error al cargar pedido mínimo:", error);
          $this.loading = false;
          $this.showToast("No se pudo cargar el listado de pedidos mínimos", "danger");
        });
    },
    ...mapActions({
      getDistributorList: "distribuidora/getList",
    }),
    async fetchDistribuidoras() {
      try {
        const result = await this.getDistributorList();
        this.distribuidoras = result.data
          ? result.data.filter((item) => {
              return item.estado == "1";
            })
          : [];
      } catch (error) {
        console.log("Error al cargar distribuidoras:", error);
        this.distribuidoras = [];
      }
    },
    changeData() {
      this.filter.page = 1;
      this.fetchPedidoMinimoData();
    },
    deletePedido(idPedido) {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      this.loading = true;
      const urlDelete = `${process.env.VUE_APP_API_URL}/pedidominimo/eliminar/${idPedido}`;
      axios
        .get(urlDelete, config)
        .then(() => {
          // Keep current filters/page and refresh table in-place (SPA friendly).
          this.showToast("Se eliminó el pedido mínimo");
          return this.fetchPedidoMinimoData();
        })
        .catch((error) => {
          console.log("Error al eliminar pedido mínimo:", error);
          this.showToast("No se pudo eliminar el pedido mínimo", "danger");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changePaginate() {
      this.$nextTick(() => {
        this.fetchPedidoMinimoData();
      });
    },
  },
  data() {
    return {
      loading: true,
      filter: {
        iddistribuidora: 0,
        nombreCombinacion: "",
        tipo: 0,
        page: 1,
      },
      distribuidoraIdCurrent: null,
      distribuidoras: [],
      pagination: {
        perPage: 25,
        currentPage: 1,
        newcurrentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      tableColumns: [
        {
          prop: "distribuidora",
          label: "Distribuidora",
          width: 160,
        },
        {
          prop: "nombreCombinacion",
          label: "Descripción",
          width: 180,
        },
      ],
      tableData: [],
    };
  },
};
</script>
